import React, { Component } from 'react';
import PropTypes from 'prop-types';

import NoCheck from '../../assets/images/svg/noChecks.svg';

class NoChecks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 24,
      height: 24,
    };
  }

  setState() {
    this.setState = {
      width: this.props.width,
      height: this.props.height,
    };
  }

  render() {
    return (
      <div className={this.props.className}>
        <img
          src={NoCheck}
          width={this.state.width}
          height={this.state.height}
          alt={'icone-noCheck'}
          loading='lazy'
        />
      </div>
    );
  }
}

NoChecks.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default NoChecks;
